import { PowerOfAttorneyFlags, PowerOfAttorneyModel } from "api";
import { dateToView } from "helpers/date";

export function isPaperPowerOfAttorney(powerOfAttorney: PowerOfAttorneyModel) {
    return (powerOfAttorney.intFlags & PowerOfAttorneyFlags.IsPaper) === PowerOfAttorneyFlags.IsPaper;
}

export function powerOfAttorneyLabel(powerOfAttorney: PowerOfAttorneyModel) {
    const type = isPaperPowerOfAttorney(powerOfAttorney) ? "Бумажная" : "МЧД";
    const issueDate = powerOfAttorney.issueDate ? ` от ${dateToView(powerOfAttorney.issueDate)}` : "";
    return `${type}: ${powerOfAttorney.externalId || "без номера"}${issueDate}`;
}
